import React from 'react'
import { l } from '@manychat/manyui'

export const InstagramConnectionWasSuccessfullyReloadedNotification = () => {
  return <span>{l.translate('Instagram channel permissions successfully refreshed')}</span>
}
